<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{
                $t(isNew ? "CRUD.newInfo" : "CRUD.info", [
                  $t("stockInOrders.ObjectName"),
                ])
              }}
              <v-chip
                v-if="stock_ins.cancel_flg"
                small
                label
                outlined
                class="ms-4 mt-1"
                color="danger"
              >
                {{ $t("CRUD.cancelled") }}
              </v-chip>
              <v-chip
                v-if="!isNew"
                small
                label
                class="ms-4 mt-1"
                :color="stock_ins.status | stockOrderINStatusColor"
                :text-color="stock_ins.status | stockOrderINStatusTextColor"
                >{{ stock_ins.status | stockOrderINStatusText }}
              </v-chip>
              <v-spacer />
              <StockOrderOUTActions
                v-if="isView || mode == 'in'"
                :stock_in="stock_ins"
                @edit="mode = 'edit'"
                showEdit
                showCancel
                detail-mode
              />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <!-- 提交 -->
                <v-btn
                  v-if="isNew"
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="doSubmit()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("stockInOrders.actions.submitStockIn") }}
                </v-btn>
                <!-- <v-btn
                  v-if="mode == 'edit'"
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="doSubmit()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("stockInOrders.actions.editStockINSubmit") }}
                </v-btn> -->
                <!-- 编辑 -->
                <v-btn
                  v-if="
                    stock_ins.actions &&
                    stock_ins.actions.in_edit &&
                    isView &&
                    $permission.permissionAllow('StockInOrders', 'edit')
                  "
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    $router.push('/stock-in-orders/' + stock_ins.id + '/edit')
                  "
                >
                  <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                  {{ $t("stockInOrders.actions.edit") }}
                </v-btn>
                <!-- 入库 -->
                <v-btn
                  v-if="
                    stock_ins.actions &&
                    stock_ins.actions.in_complete &&
                    isView &&
                    $permission.permissionAllow('StockInOrders', 'in')
                  "
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    productionStockINFlg
                      ? $router.push(
                          '/production-stock-in/' + stock_ins.id + '/in'
                        )
                      : $router.push('/stock-in-orders/' + stock_ins.id + '/in')
                  "
                >
                  <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                  {{ $t("stockInOrders.actions.stockIn") }}
                </v-btn>
                <!-- 确认入库 -->
                <v-btn
                  v-if="
                    stock_ins.actions &&
                    stock_ins.actions.in_complete &&
                    isIn &&
                    $permission.permissionAllow('StockInOrders', 'in')
                  "
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click.stop="checkActions()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("stockInOrders.actions.confirmStockIn") }}
                </v-btn>
                <!-- 编辑保存 -->
                <v-btn
                  v-if="
                    stock_ins.actions &&
                    stock_ins.actions.in_complete &&
                    stock_ins.actions.in_edit &&
                    isEdit &&
                    $permission.permissionAllow('StockInOrders', 'edit')
                  "
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="doSubmit()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("stockInOrders.actions.editStockINSubmit") }}
                </v-btn>
                <!-- 部分入库 -->
                <!-- <v-btn
                  v-if="isStockIn"
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="doSubmit('part_in')"
                >
                  {{ $t("stockInOrders.actions.stockPartIn") }}
                </v-btn> -->
                <v-btn
                  v-if="
                    isView &&
                    $permission.permissionAllow('StockInOrders', 'detailExport')
                  "
                  small
                  dark
                  color="print"
                  class="px-2 me-2 mb-1"
                  @click="stockTakeOrdersExport()"
                >
                  <v-icon x-small class="pe-1">fa-file-export</v-icon>
                  {{ $t("StockTakes.actions.export") }}
                </v-btn>
              </v-sheet>
            </v-card-title>
          </v-expansion-panel-header>

          <ValidationObserver ref="observer">
            <v-expansion-panel-content>
              <v-divider />
              <v-row no-gutters class="mt-4 table-style">
                <!-- 出库单编号 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockInOrders.Fields.stock_in_code")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_ins.stock_order_code }}
                  </v-card>
                </v-col>
                <!-- 仓库名称 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockInOrders.Fields.stock_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ $t("stockInOrders.Fields.default_stock_name") }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 创建时间 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockInOrders.Fields.created_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_ins.created | formatTime }}
                  </v-card>
                </v-col>

                <!-- 入库类型 -->
                <v-col cols="12" :md="stockInitialize ? 6 : 4">
                  <v-card
                    class="pa-2 text-no-wrap d-flex"
                    outlined
                    tile
                    v-if="isNew"
                  >
                    <span class="secondary--text">
                      {{ $t("stockInOrders.Fields.stock_in_type")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-select
                      v-if="isNew && !stockInitialize"
                      v-model="stock_ins.type"
                      :items="
                        $consts.stock_in_order.types.filter(
                          (element) =>
                            element.value == 11 || element.value == 14
                        )
                      "
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                    >
                    </v-select>
                    <span v-else>
                      {{ $t("stockInOrders.types.init_stock_in") }}
                    </span>
                  </v-card>
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile v-else>
                    <span class="secondary--text">
                      {{ $t("stockInOrders.Fields.stock_order_type")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>{{ stock_ins.in_type_str }}</span>
                  </v-card>
                </v-col>
                <!-- 仓库名称 -->
                <v-col
                  cols="12"
                  :md="isNew ? (stockInitialize ? 6 : 4) : 8"
                  v-if="isNew"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockInOrders.Fields.stock_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ $t("stockInOrders.Fields.default_stock_name") }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 实际发生时间 -->
                <v-col cols="12" md="4" v-if="isNew && !stockInitialize">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockInOrders.Fields.actual_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      class="my-n2"
                      v-model="stock_ins.actual_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                    >
                    </SearcherDatetime>
                  </v-card>
                </v-col>
                <!-- 供应商 -->
                <v-col cols="12" md="4" v-if="stock_ins.type == 11">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockInOrders.Fields.supplier")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-text-field
                      v-if="isNew"
                      v-model="stock_ins.supplier_name"
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                    ></v-text-field>
                    <span v-else>
                      {{ stock_ins.supplier_name }}
                    </span>
                  </v-card>
                </v-col>

                <!-- 出库时间 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockInOrders.Fields.finish_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{
                        stock_ins.type == 3
                          ? stock_ins.actual_finish_time
                          : stock_ins.finish_time | formatTime
                      }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 实际发生时间 -->
                <v-col cols="12" md="4" v-if="!isNew && !stockInitialize">
                  <v-card v-if="isEdit">
                    <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                      <span class="secondary--text">
                        {{ $t("stockInOrders.Fields.actual_time")
                        }}{{ $t("Global.colon") }}
                      </span>
                      <SearcherDatetime
                        class="my-n2"
                        v-model="stock_ins.actual_date"
                        type="datetime"
                        single-line
                        dense
                        hide-details
                      >
                      </SearcherDatetime>
                    </v-card>
                  </v-card>
                  <v-card v-else class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockInOrders.Fields.actual_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_ins.actual_date | formatTime }}
                  </v-card>
                </v-col>
                <!-- 调出门店名称 -->
                <v-col cols="12" md="4" v-if="stock_ins.type == 6">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockInOrders.Fields.out_shop")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_ins.requisition_shop.shop_name }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 备注 -->
                <v-col cols="12" :md="isNew ? 8 : 12" v-if="!stockInitialize">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text"
                      >{{ $t("stockInOrders.Fields.attachment")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-text-field
                      v-if="savable"
                      v-model="stock_ins.memo"
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                    />
                    <span v-else>
                      {{ stock_ins.memo }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 附件 -->
                <!-- v-if="stock_ins.type == 2" -->
                <v-col cols="12" md="12" v-if="!stockInitialize">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text"
                      >{{ $t("stockInOrders.Fields.attachment_images")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <!-- 上传图片集 -->
                    <span class="ml-4">
                      <v-card
                        height="160"
                        width="240"
                        v-if="album && album.length > 0"
                      >
                        <v-carousel
                          hide-delimiters
                          cycle
                          height="160"
                          width="240"
                        >
                          <v-carousel-item
                            v-for="(item, i) in album"
                            :key="i"
                            :src="item"
                            @click.stop="$showFullscreenImages(album, i)"
                          >
                            <v-tooltip
                              right
                              v-if="(savable || isStockIn) && item"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  color="secondary"
                                  class="pa-2 float-right"
                                  @click.stop="removeFromImages(i)"
                                >
                                  fa-times
                                </v-icon>
                              </template>
                              <span> {{ $t("Material.delImg") }}</span>
                            </v-tooltip>
                          </v-carousel-item>
                        </v-carousel>
                      </v-card>
                      <v-file-input
                        ref="imgs_file"
                        v-show="savable || isStockIn"
                        show-size
                        counter
                        small-chips
                        multiple
                        suffix
                        prepend-icon="fa-camera"
                        accept="image/png, image/jpeg"
                        persistent-hint
                        :placeholder="$t('Material.imgsPlaceholder')"
                        :hint="$t('Material.imgsHint')"
                        :rules="imgsRules"
                        v-model="imgs_file"
                      >
                      </v-file-input>
                    </span>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </ValidationObserver>
        </v-expansion-panel>
        <v-expansion-panel v-if="!isNew">
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                @click.stop="
                  tab = 0;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("ActivityFields.activities") }}
              </v-tab>
              <v-tab
                @click.stop="
                  tab = 1;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
                v-if="stock_ins.type == 2 || stock_ins.type == 7"
              >
                {{ $t("stockInOrders.relations") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="stock_out_activities"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat v-if="stock_ins.type == 2">
                  <v-data-table
                    :headers="relationsHeaders"
                    :items="relations_orders"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
                <v-card flat v-if="stock_ins.type == 7">
                  <v-data-table
                    :headers="relationsProductionHeaders"
                    :items="relations"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        v-if="
                          $permission.permissionAllow(item.controller, 'view')
                        "
                        small
                        outlined
                        color="info"
                        class="px-2 me-2"
                        :href="'/#/' + item.identify + '/' + item.id"
                      >
                        <v-icon x-small class="pe-1">fa-align-left</v-icon>
                        {{ $t("Opt.details") }}
                      </v-btn>
                    </template>
                    <template v-slot:item.status="{ item }"
                      ><v-chip
                        v-if="item.controller == 'ProductionPlans'"
                        small
                        label
                        class="ms-4 mt-1"
                        :color="item.status | productionPlansStatusColor"
                        :text-color="
                          item.status | productionPlansStatusTextColor
                        "
                        >{{ item.status | productionPlansStatusText }}
                      </v-chip>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-data-table
        :headers="detailsHeaders"
        :items="stockInDetails"
        :search="filter"
        multi-sort
        class="elevation-2 px-4 mt-4"
        disable-pagination
        hide-default-footer
        :no-data-text="$t('stockInOrders.DetailNoData')"
      >
        <template v-slot:top>
          <v-toolbar flat class="transparent-background-color">
            <v-toolbar-title class="ms-n2">
              {{ $t("CRUD.details", [$t("stockInOrders.ObjectName")]) }}
            </v-toolbar-title>
            <v-spacer />
            <!-- 期初入库 -->
            <v-btn
              color="primary"
              samll
              dark
              class="px-2 me-2 mb-1"
              v-if="stockInitialize"
              @click="initializeDialog = true"
            >
              <v-icon x-small class="pe-1">fa-file-import</v-icon>
              {{ $t("CurrentStocks.exportStockInitialize") }}
            </v-btn>
            <!-- 导入商品 -->
            <v-btn
              color="primary"
              samll
              dark
              class="px-2 me-2 mb-1"
              v-if="!stockInitialize && isNew"
              @click="ImportMaterialsDialog = true"
            >
              {{ $t("Import.import", [$t("Material.ObjectName")]) }}
            </v-btn>
            <!-- 选择商品 -->
            <v-btn
              color="primary"
              samll
              dark
              class="px-2 me-2 mb-1"
              v-if="isNew || isEdit"
              @click="Dialog = true"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
            </v-btn>
          </v-toolbar>
          <v-divider />
          <v-toolbar
            flat
            class="transparent-background-color"
            align-self="center"
          >
            <span class="caption secondary--text pt-2">
              {{
                $t(
                  "$vuetify.dataFooter.pageText",
                  stockInDetails.length
                    ? [1, stockInDetails.length, stockInDetails.length]
                    : [0, 0, 0]
                )
              }}
            </span>
            <v-spacer />
            <v-row no-gutters class="me-n3">
              <v-spacer />
              <v-col cols="12" sm="9" md="8">
                <v-text-field
                  v-model="filter"
                  clearable
                  hide-details
                  :label="$t('Search.filter')"
                />
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:item.material_img="{ item }">
          <MaterialThumbnail :material="item.material || item" />
        </template>
        <template v-if="stockInDetails.length" v-slot:body.prepend>
          <tr no-gutters class="d-none d-sm-table-row">
            <td
              class="secondary--text"
              :colspan="
                accountSettings && accountSettings.material_image ? 2 : 1
              "
            >
              {{ $t("stockInOrders.DetailFields.count_num") }}
            </td>
            <td
              class="secondary--text"
              :colspan="isView && stock_ins.type == 2 ? '5' : '4'"
            ></td>
            <td class="align-end text-right">
              {{ count_order_num }}
            </td>
            <td
              v-if="(isView || isIn) && stock_ins.type != 2"
              class="align-end text-right"
            >
              {{ count_confirm_num }}
            </td>
            <td class="align-end text-right">
              {{ $t("Global.money") }}{{ count_price | formatMoneyFloor }}
            </td>
            <td
              :colspan="
                accountSettings && accountSettings.product_date_setting ? 3 : 1
              "
            ></td>
            <td v-if="isNew || isEdit"></td>
            <td
              v-if="
                isView &&
                stock_ins.type == 2 &&
                accountSettings &&
                accountSettings.qualify_report_enable
              "
            ></td>
          </tr>
          <tr no-gutters class="d-table-row d-sm-none">
            <td class="v-data-table__mobile-row">
              <div class="v-data-table__mobile-row__header">
                {{
                  accountSettings && accountSettings.material_image
                    ? $t("stockInOrders.DetailFields.material_img")
                    : $t("stockInOrders.DetailFields.stock_in_order_num")
                }}
              </div>
              <div class="v-data-table__mobile-row__cell">
                {{ count_order_num }}
              </div>
            </td>
            <td class="v-data-table__mobile-row">
              <div class="v-data-table__mobile-row__header">
                {{ $t("stockInOrders.DetailFields.stock_in_practical_num") }}
              </div>
              <div class="v-data-table__mobile-row__cell">
                {{ count_confirm_num }}
              </div>
            </td>
            <td class="v-data-table__mobile-row">
              <div class="v-data-table__mobile-row__header">
                {{ $t("stockInOrders.DetailFields.total") }}
              </div>
              <div class="v-data-table__mobile-row__cell">
                {{ $t("Global.money") }}{{ count_price | formatMoneyFloor }}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:header.order_num="{ header }">
          <span v-if="!isNew && stock_ins.type == 11">
            {{ $t("stockInOrders.DetailFields.stock_in_purchase_num") }}
          </span>
          <span v-else-if="!isNew && stock_ins.type == 3">
            {{ $t("stockInOrders.DetailFields.profit_num") }}
          </span>
          <span v-else-if="!isNew && stock_ins.type == 6">
            {{ $t("stockInOrders.DetailFields.requisitions_num") }}
          </span>
          <span v-else>
            {{ header.text }}
          </span>
        </template>
        <template v-slot:header.actions="{ header }">
          {{ header.text }}
          <v-icon x-small>fa-sliders-h</v-icon>
        </template>

        <template v-slot:item.Description="{ item }">
          <a
            class="text-no-wrap"
            :class="item.error_flg ? 'red--text' : ''"
            @click.stop="dialogMaterialID = item.material_id"
          >
            {{ item.Description }}
          </a>
        </template>

        <template v-slot:item.material_name="{ item }">
          <span class="text-no-wrap">
            {{item.material_name, }}
          </span>
          <br />
          <span v-if="item.standard_name" class="caption secondary--text">
            {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")
            }}<span
              v-if="item.standard_name && item.standard_name.length > 12"
              :title="item.standard_name"
              style="cursor: pointer"
            >
              {{ item.standard_name.slice(0, 12) + "......" }}
            </span>
            <span v-else>
              {{ item.standard_name }}
            </span>
          </span>
        </template>
        <template v-slot:item.unit="{ item }">
          <span>{{ item.unit }} </span>
        </template>

        <template v-slot:item.order_num="{ item }">
          <NumberInput v-if="savable && !isIn" v-model="item.order_num" dense />
          <span v-else>
            {{ item.order_num }}
          </span>
        </template>
        <template v-slot:item.confirm_num="{ item }">
          <NumberInput
            v-if="savable && isIn"
            v-model="item.confirm_num"
            dense
          />
          <span v-else>
            {{ item.confirm_num }}
          </span>
        </template>
        <template v-slot:header.price="{ header }">
          <span class="text-center text-no-wrap">
            {{ header.text }}
            <br />
            <a
              v-if="isNew && stock_ins.price_type != 1 && stock_ins.type == 11"
              @click.stop="stock_ins.price_type = 1"
              >{{ $t("stockInOrders.DetailFields.enterPrice") }}</a
            >
          </span>
        </template>
        <template v-slot:item.price="{ item }">
          <v-text-field
            v-if="
              savable &&
              ((stock_ins.price_type == 1 && stock_ins.type == 11) ||
                stock_ins.type != 11)
            "
            v-model="item.price"
            single-line
            dense
            hide-details
            type="number"
            min="0"
            :prefix="$t('Global.money')"
            @blur="
              item.price = $numberFormatter.formatMoneyFloorWithTwoDot(
                item.price,
                2
              )
            "
            style="max-width: 80px; margin-left: auto"
          />
          <span v-else>
            {{ $t("Global.money") }}
            {{ item.price | formatMoneyFloor }}
          </span>
        </template>
        <template v-slot:header.total="{ header }">
          <span class="text-center text-no-wrap">
            {{ header.text }}
            <br />
            <a
              v-if="isNew && stock_ins.price_type != 2 && stock_ins.type == 11"
              @click.stop="stock_ins.price_type = 2"
              >{{ $t("stockInOrders.DetailFields.enterSub") }}</a
            >
          </span>
        </template>
        <template v-slot:item.total="{ item }">
          <!-- <span>
            {{ $t("Global.money") }}
            {{ (item.price * item.order_num) | formatMoney }}
          </span> -->
          <v-text-field
            v-if="savable && stock_ins.price_type == 2 && stock_ins.type == 11"
            v-model="item.fee"
            single-line
            dense
            hide-details
            type="number"
            min="0"
            :prefix="$t('Global.money')"
            @blur="
              item.fee = $numberFormatter.formatMoneyFloorWithTwoDot(item.fee, 2)
            "
            style="max-width: 80px; margin-left: auto"
          />
          <span v-else>
            {{ $t("Global.money") }}
            {{ item.fee | formatMoneyFloor }}
          </span>
        </template>
        <template v-slot:item.production_date="{ item }">
          <SearcherDatetime
            v-if="savable || stockInitialize"
            class="my-n2"
            v-model="item.production_date"
            type="date"
            single-line
            dense
            hide-details
            hide-icon
            disabled-after-now
          >
          </SearcherDatetime>
          <span v-else>{{ item.production_date | formatDate }}</span>
        </template>
        <template v-slot:item.expired_date="{ item }">
          <SearcherDatetime
            v-if="savable || stockInitialize"
            class="my-n2"
            v-model="item.expired_date"
            type="date"
            single-line
            dense
            hide-details
            hide-icon
            disabled-before-today
          >
          </SearcherDatetime>
          <span v-else>{{ item.expired_date | formatDate }}</span>
        </template>
        <template v-slot:item.memo="{ item }">
          <v-text-field
            v-if="isNew || isEdit"
            v-model="item.memo"
            single-line
            dense
            hide-details
            class="d-inline mt-0 mb-n1"
          >
            <template v-slot:append>
              <v-icon x-small class="pt-2 pb-1 primary--text"> fa-edit </v-icon>
            </template>
          </v-text-field>
          <span v-else>
            {{ item.memo }}
          </span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            v-if="item.new"
            small
            text
            class="danger--text pa-0"
            @click.stop="
              stock_in_details.splice(
                stock_in_details.findIndex((detail) => item.new == detail.new),
                1
              )
            "
          >
            <v-icon>fa-times</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.qualify_report_img_url="{ item }">
          <!-- 质检报告 -->
          <v-btn
            v-if="
              stock_ins &&
              stock_ins.type == 2 &&
              item &&
              item.qualify_report_img_url &&
              item.qualify_report_img_url.length
            "
            color="orange"
            style="color: white"
            class="my-1"
            small
            @click.stop="
              currentItem = item;
              qualifyReportDialog = true;
            "
          >
            {{ $t("stockInOrders.DetailFields.qualify_report_img_url") }}
          </v-btn>
        </template>
        <template v-slot:footer>
          <v-row
            v-if="isNew || isEdit"
            no-gutters
            align="center"
            class="ps-1 text-no-wrap d-flex"
          >
            <span class="secondary--text">
              {{ $t("CRUD.newInfo", [$t("Material.ObjectName")])
              }}{{ $t("Global.colon") }}
            </span>
            <SearcherMaterial
              v-model="addMaterial"
              :stockId="stock_ins.stock_id"
              :disabledItems="
                stock_in_details
                  ? stock_in_details.map((detail) => {
                      return { material_id: detail.material_id };
                    })
                  : []
              "
              no-label
              :stockType="stockType"
            />
          </v-row>
        </template>
      </v-data-table>
    </v-sheet>
    <ImportExcelAlert
      v-model="initializeDialog"
      :objName="$t('stockInOrders.InitializeMaterial')"
      downloadFromAPI
      @import="
        excelFile = $event;
        importExcel();
      "
      @download="downloadTemplate($event)"
    />
    <MaterialsSelectsDialog
      v-model="Dialog"
      @confirm="addMaterials = $event"
      :disabledItems="stock_in_details"
    />

    <DialogImages
      v-model="qualifyReportDialog"
      :img_url="
        currentItem && currentItem.qualify_report_img_url
          ? currentItem.qualify_report_img_url
          : []
      "
    />

    <ImportMaterialsDialog
      v-model="ImportMaterialsDialog"
      :orderType="stock_ins.type"
      type="stock_in_order"
      :objName="$t('Material.ObjectName')"
      :mode="this.mode"
      @import="
        excelFile = $event;
        importMaterials();
      "
    />
  </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import StockIns from "@/api/stock_in_orders";
import StockOrderOUTActions from "./plugins/Actions";
// import { ValidationObserver, ValidationProvider } from "vee-validate";
import { ValidationObserver } from "vee-validate";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import SearcherMaterial from "@/components/plugins/SearcherMaterial";
import NumberInput from "@/components/plugins/NumberInput";
import Shops from "@/api/shops";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";
import { mapState } from "vuex";
import MaterialsSelectsDialog from "@/components/plugins/MaterialsSelectsDialog";
import ImportMaterialsDialog from "@/components/plugins/ImportMaterialsDialog";
import MaterialThumbnail from "@/components/plugins/MaterialThumbnail";
import DialogImages from "@/components/plugins/DialogImages";
import Files from "@/api/files";

export default {
  components: {
    Breadcrumbs,
    StockOrderOUTActions,
    ValidationObserver,
    // ValidationProvider,
    SearcherDatetime,
    SearcherMaterial,
    NumberInput,
    ImportExcelAlert,
    MaterialsSelectsDialog,
    DialogImages,
    ImportMaterialsDialog,
    MaterialThumbnail,
  },
  data: () => ({
    productionStockINFlg: false,
    tab: null,
    mode: "",
    stock_ins: { type: 11, price_type: 1 },
    stock_out_activities: [],
    relations_orders: [],
    panels: [0],
    filter: "",
    stock_in_details: [],
    addMaterial: null,
    addMaterials: [],
    stockType: null,
    initializeDialog: false,
    excelFile: null,
    stockDialog: false,
    Dialog: false,
    ImportMaterialsDialog: false,
    count_price: null,
    count_order_num: null,
    count_confirm_num: null,
    relations: [],
    currentItem: null,
    qualifyReportDialog: false,
    imgs_file: [],
    imgsRules: [
      (value) =>
        !value ||
        value.filter((v) => v.size >= 10000000).length == 0 ||
        i18n.t("Material.imgsHint"),
    ],
    album: [],
  }),
  mounted() {
    if (this.$route.path.startsWith("/stock-in-orders/new")) {
      this.productionStockINFlg = false;
      this.mode = "new";
    } else if (this.$route.path.startsWith("/current-stocks/initialize")) {
      this.mode = "stockInitialize";
      this.stock_ins.type = 5;
    } else {
      this.mode = this.$route.params.mode;
      if (this.$route.path.startsWith("/production-stock-in")) {
        this.productionStockINFlg = true;
        if (this.mode) {
          this.$router.replace("/production-stock-in/" + this.$route.params.id);
        }
      } else if (this.$route.path.startsWith("/stock-in-orders")) {
        this.productionStockINFlg = false;
        if (this.mode) {
          this.$router.replace("/stock-in-orders/" + this.$route.params.id);
        }
      }
    }
  },
  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return (
        this.mode == "new" ||
        this.mode == "edit" ||
        this.mode == "in" ||
        this.mode == "stockInitialize"
      );
    },
    isStockIn() {
      return this.mode == "in";
    },
    isNew() {
      return this.mode == "new" || this.mode == "stockInitialize";
    },
    stockInitialize() {
      return this.mode == "stockInitialize";
    },
    isEdit() {
      return this.mode == "edit";
    },
    isIn() {
      return this.mode == "in";
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: this.productionStockINFlg
            ? i18n.t("Nav.productionManagement")
            : i18n.t("Nav.stockManagement"),
          disabled: false,
          replace: true,
          href: this.productionStockINFlg
            ? "/production-plans"
            : "/current-stocks",
        },
        {
          text: this.stockInitialize
            ? i18n.t("Nav.currentStocks")
            : this.productionStockINFlg
            ? i18n.t("Nav.productionStockIN")
            : i18n.t("Nav.stockInOrders"),
          disabled: false,
          href: this.stockInitialize
            ? "/current-stocks"
            : this.productionStockINFlg
            ? "/production-stock-in"
            : "/stock-in-orders",
        },
        {
          text: this.isNew
            ? this.stockInitialize
              ? i18n.t("CurrentStocks.stockInitialize")
              : i18n.t("Nav.stockInsNew")
            : i18n.t("Nav.stockInsDetail"),
          disabled: true,
        },
      ];
      if (!this.isNew) {
        items.push({
          text:
            this.stock_ins && this.stock_ins.stock_order_code
              ? this.stock_ins.stock_order_code
              : "",
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    detailsHeaders() {
      var headers = [];
      if (this.accountSettings && this.accountSettings.material_image) {
        headers.push({
          text: i18n.t("stockInOrders.DetailFields.material_img"),
          align: "start",
          sortable: false,
          value: "material_img",
        });
      }
      headers.push({
        text: i18n.t("stockInOrders.DetailFields.category"),
        align: "start",
        class: "text-no-wrap",
        value: "category_name",
      });
      headers.push({
        text: i18n.t("stockInOrders.DetailFields.material_code"),
        align: "start",
        value: "material_code",
      });
      headers.push(
        {
          text: i18n.t("stockInOrders.DetailFields.material_name"),
          align: "start",
          value: "material_name",
        },
        {
          text: i18n.t("stockInOrders.DetailFields.unit"),
          align: "start",
          value: "unit",
        },
        {
          text: i18n.t("stockInOrders.DetailFields.stock_in_price"),
          align: "end",
          value: "price",
        }
      );

      if (this.isView && this.stock_ins.type == 2) {
        headers.push({
          text: i18n.t("stockInOrders.DetailFields.examines_num"),
          align: "end",
          value: "confirm_num",
        });
      }
      // if (this.savable) {
      headers.push({
        text: i18n.t("stockInOrders.DetailFields.stock_in_order_num"),
        align: "end",
        value: "order_num",
      });
      // }
      // if (this.isView) {
      //   headers.push({
      //     text: i18n.t("stockInOrders.DetailFields.stock_in_practical_num"),
      //     align: "end",
      //     value: "order_num",
      //   });
      // }
      // if (this.isView && this.stock_ins.status == 3) {
      if ((this.isIn || this.isView) && this.stock_ins.type != 2) {
        headers.push({
          text: i18n.t("stockInOrders.DetailFields.stock_in_practical_num"),
          align: "end",
          sortable: false,
          value: "confirm_num",
        });
      }
      headers.push({
        text: i18n.t("stockInOrders.DetailFields.total"),
        align: "end",
        sortable: false,
        value: "total",
      });
      // }
      if (
        this.accountSettings &&
        this.accountSettings.product_date_setting == 1
      ) {
        headers.push(
          {
            text: i18n.t("stockInOrders.DetailFields.production_date"),
            align: "start",
            value: "production_date",
            width: 136,
          },
          {
            text: i18n.t("stockInOrders.DetailFields.expired_date"),
            align: "start",
            value: "expired_date",
            width: 136,
          }
        );
      }
      headers.push({
        text: i18n.t("stockInOrders.DetailFields.memo"),
        align: "start",
        sortable: false,
        width: "130px",
        value: "memo",
      });
      if (this.isNew || this.isEdit) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      if (
        this.isView &&
        this.stock_ins.type == 2 &&
        this.accountSettings &&
        this.accountSettings.qualify_report_enable
      ) {
        headers.push({
          text: i18n.t("stockInOrders.DetailFields.qualify_report_img_url"),
          align: "start",
          value: "qualify_report_img_url",
        });
      }

      return headers;
    },
    stockInDetails() {
      return this.stock_in_details.map((detail) => {
        detail.Description = i18n.t("Material.materialNameWithCode", [
          detail.material_code,
          detail.material_name,
        ]);
        return detail;
      });
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    relationsHeaders: () => [
      {
        text: i18n.t("stockInOrders.relationsFields.type"),
        align: "center",
        sortable: false,
        value: "type",
      },
      {
        text: i18n.t("stockInOrders.relationsFields.code"),
        align: "center",
        sortable: false,
        value: "code",
      },
      {
        text: i18n.t("stockInOrders.relationsFields.created_time"),
        align: "center",
        sortable: false,
        value: "created",
      },
    ],
    relationsProductionHeaders() {
      var headers = [
        {
          text: i18n.t("ProductionPlans.RelationFields.identify_name"),
          align: "center",
          sortable: false,
          value: "identify_name",
        },
        {
          text: i18n.t("ProductionPlans.RelationFields.identify_code"),
          align: "center",
          sortable: false,
          value: "identify_code",
        },
        {
          text: i18n.t("ProductionPlans.RelationFields.status"),
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("ProductionPlans.RelationFields.created_time"),
          align: "start",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];

      return headers;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountSettings"]),
  },
  methods: {
    getStockInsFromAPI() {
      var options = {
        order_activity: 1,
      };
      StockIns.fetchOne(this.$route.params.id, options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_ins = response.data.stock_in;
            // 继承接口下发的附件（独立副本，页面删除与提交数据源互不影响）
            this.album = response.data.stock_in.img
              ? response.data.stock_in.img.slice()
              : [];
            this.stock_out_activities = response.data.order_activities;
            if (response.data.relations_orders) {
              this.relations_orders.push({
                type: "订单",
                code: response.data.relations_orders.order.order_code,
                created: response.data.relations_orders.order.created,
              });
              this.relations_orders.push({
                type: "验收单",
                code: response.data.relations_orders.examine.examine_code,
                created: response.data.relations_orders.examine.created,
              });
            }
            if (this.stock_ins.type == 7) {
              this.relations = [];
              this.relations.push(
                Object.assign(
                  {
                    controller: "ProductionPlans",
                    identify: "production-plans",
                    identify_name: i18n.t("ProductionPlans.ObjectName"),
                    identify_code:
                      response.data.stock_in.production_plan.production_code,
                  },
                  response.data.stock_in.production_plan
                )
              );
            }
            this.stock_ins.stock_order_details.forEach((detail) => {
              detail.fee = detail.fee
                ? detail.fee
                : this.stock_ins.status == 2
                ? detail.order_num * detail.price
                : detail.confirm_num * detail.price;
            });
          }
        }.bind(this)
      );
    },
    async doSubmit(in_type) {
      this.$store.dispatch("fullscreenLoading");
      if (this.isNew) {
        if (this.$refs.imgs_file.hasError) {
          this.$store.dispatch("fullscreenLoadingStop");
          return;
        }
        //提交图片集
        var imgs = [];
        if (this.imgs_file && this.imgs_file.length > 0) {
          let response = await Files.shopFilesUpload(
            this.imgs_file,
            "shop_images"
          );

          if (response.data.status.isOK()) {
            response.data.data.forEach((img) => imgs.push(img.img_name));
          }
        }
      }
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            if (this.isNew) {
              var details = [];
              if (
                !this.stock_ins.supplier_name &&
                !this.stockInitialize &&
                this.stock_ins.type == 11
              ) {
                this.$store.dispatch("fullscreenLoadingStop");
                this.$snackbar.error(
                  i18n.t("stockInOrders.Messages.noSupplier")
                );
              } else {
                this.stockInDetails.forEach((detail) => {
                  if (
                    this.accountSettings &&
                    this.accountSettings.product_date_setting == 1
                  ) {
                    details.push({
                      material_code: detail.material_code,
                      order_num: detail.order_num,
                      memo: detail.memo,
                      price: Number(
                        this.$numberFormatter.formatMoneyFloor(detail.price)
                      ),
                      fee: detail.fee,
                      production_date: detail.production_date,
                      expired_date: detail.expired_date,
                    });
                  } else {
                    details.push({
                      material_code: detail.material_code,
                      order_num: detail.order_num,
                      memo: detail.memo,
                      price: Number(
                        this.$numberFormatter.formatMoneyFloor(detail.price)
                      ),
                      fee: detail.fee,
                    });
                  }
                });
                StockIns.add(
                  Object.assign({}, this.stock_ins, {
                    stock_order_details: details,
                    img: imgs,
                  })
                )
                  .then(
                    function (response) {
                      if (response.data.status.isOK()) {
                        this.$refs.observer.reset();
                        this.$router.push("/stock-in-orders");
                      }
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  )
                  .catch(
                    function () {
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  );
              }
            }
            if (this.isEdit) {
              // 老附件（接口下发，含编辑环节的删减，仅取文件名）+ 本次新增附件，随提交参数下发
              var edit_img = this.oldImgNames();
              var editImgNames = await this.uploadImgs();
              if (editImgNames === null) {
                this.$store.dispatch("fullscreenLoadingStop");
                return;
              }
              editImgNames.forEach((img_name) => edit_img.push(img_name));
              StockIns.edit(
                this.stock_ins.id,
                Object.assign({}, this.stock_ins, { img: edit_img })
              )
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.$refs.observer.reset();
                      if (this.productionStockINFlg) {
                        this.$router.push("/production-stock-in");
                      } else {
                        this.$router.push("/stock-in-orders");
                      }
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            }
            if (in_type == "in") {
              // 老附件（接口下发，含入库环节的删减，仅取文件名）+ 本次新增附件，随提交参数下发
              var in_img = this.oldImgNames();
              var inImgNames = await this.uploadImgs();
              if (inImgNames === null) {
                this.$store.dispatch("fullscreenLoadingStop");
                return;
              }
              inImgNames.forEach((img_name) => in_img.push(img_name));
              var inDetails = [];
              this.stockInDetails.forEach((detail) => {
                if (
                  this.accountSettings &&
                  this.accountSettings.product_date_setting == 1
                ) {
                  inDetails.push({
                    id: detail.id,
                    confirm_num: detail.confirm_num,
                    price: Number(
                      this.$numberFormatter.formatMoneyFloor(detail.price)
                    ),
                    fee: detail.fee,
                    production_date: detail.production_date,
                    expired_date: detail.expired_date,
                  });
                } else {
                  inDetails.push({
                    id: detail.id,
                    confirm_num: detail.confirm_num,
                    price: Number(
                      this.$numberFormatter.formatMoneyFloor(detail.price)
                    ),
                    fee: detail.fee,
                  });
                }
              });
              StockIns.stockIn(
                Object.assign(
                  {},
                  {
                    id: this.stock_ins.id,
                    memo: this.stock_ins.memo,
                    img: in_img,
                  },
                  { stock_order_details: inDetails }
                )
              )
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.$refs.observer.reset();
                      if (this.productionStockINFlg) {
                        this.$router.push("/production-stock-in");
                      } else {
                        this.$router.push("/stock-in-orders");
                      }
                    } else if (
                      response.data.error &&
                      response.data.data.length
                    ) {
                      this.errorMaterialInfoAlert = true;
                      this.errorMaterialsList = response.data.data;
                      if (response.data.error.code == "ERR752") {
                        this.errorMsg = i18n.t(
                          "stockInOrders.Messages.some_materials_no_exist"
                        );
                      } else if (response.data.error.code == "ERR810") {
                        this.errorMsg = i18n.t(
                          "stockInOrders.Messages.negative_inventory_out_err"
                        );
                      }
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    checkActions() {
      Shops.checkAction(2).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.data.actions) {
              this.doSubmit("in");
            } else {
              this.$snackbar.error(i18n.t(response.data.data.msg));
            }
          }
        }.bind(this)
      );
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      StockIns.imports(this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(
                i18n.t("Import.success", [
                  i18n.t("stockInOrders.InitializeMaterial"),
                ])
              );
              this.$router.push("/current-stocks");
              this.initializeDialog = false;
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    stockTakeOrdersExport() {
      StockIns.orderExport(this.stock_ins.id);
    },
    importMaterials() {
      this.$store.dispatch("fullscreenLoading");
      //商品导入
      StockIns.importMaterials(
        this.excelFile,
        this.accountSettings.product_date_setting
      )
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(
                i18n.t("Import.success", [i18n.t("Material.ObjectName")])
              );
              this.ImportMaterialsDialog = false;
              let materials = response.data.materials;
              this.stock_in_details = [];
              materials.forEach((material) => {
                this.stock_in_details.push({
                  new: this.stock_in_details.length + 1,
                  stock_in_id: this.stock_ins.id,
                  category_name: material.category_name,
                  material_id: material.material_id,
                  material_code: material.material_code,
                  material_name: material.material_name,
                  unit: material.default_unit,
                  price: material.supply_price,
                  memo: material.memo,
                  fee: material.fee,
                  material: material,
                  standard_detail_id: material.default_standard_detail_id,
                  order_num: material.order_num,
                  production_date: material.production_date,
                  expired_date: material.expired_date,
                });
              });
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    downloadTemplate(categoryCode) {
      StockIns.initializeTemplateExport({ category_code: categoryCode });
    },
    removeFromImages(i) {
      var oldCount = this.stock_ins.img ? this.stock_ins.img.length : 0;
      if (i < oldCount) {
        // 删除的是接口下发的老附件
        this.stock_ins.img.splice(i, 1);
        this.album.splice(i, 1);
      } else {
        // 删除的是新选择的文件，album 交由 imgs_file 监听重建
        this.imgs_file.splice(i - oldCount, 1);
      }
    },
    // 上传本次新增附件，返回 img_name 数组；上传异常返回 null，调用方需中止提交
    async uploadImgs() {
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.imgs_file && this.$refs.imgs_file.hasError) {
        return null;
      }
      var imgNames = [];
      if (this.imgs_file && this.imgs_file.length > 0) {
        try {
          let response = await Files.shopFilesUpload(
            this.imgs_file,
            "shop_images"
          );
          if (response.data.status.isOK()) {
            response.data.data.forEach((img) => imgNames.push(img.img_name));
          }
        } catch (error) {
          return null;
        }
      }
      return imgNames;
    },
    // 接口下发的老附件为完整url，提交时仅取文件名
    oldImgNames() {
      return (this.stock_ins.img || []).map((url) =>
        url.substring(url.lastIndexOf("/") + 1)
      );
    },
  },
  watch: {
    $route(to) {
      if (to.path.startsWith("/stock-in-orders/new")) {
        this.mode = "new";
        // 重新初始化界面
        this.tab = null;
      } else if (to.params.mode) {
        this.mode = to.params.mode;
        if (this.productionStockINFlg) {
          this.$router.replace("/production-stock-in/" + to.params.id);
        } else {
          this.$router.replace("/stock-in-orders/" + to.params.id);
        }
      }
    },
    mode: {
      handler() {
        if (this.isNew || this.stockInitialize) {
          this.stock_ins.actual_date = this.$datetimeUtils.formatTime(
            new Date()
          );
        } else if (!this.isNew && this.$route.params.id) {
          this.getStockInsFromAPI();
        }
      },
    },
    stock_ins: {
      deep: true,
      handler() {
        if (!this.isNew) {
          this.stock_in_details =
            this.stock_ins && this.stock_ins.stock_order_details
              ? this.stock_ins.stock_order_details
              : [];
        }
        if (this.stock_ins.type) {
          this.stockType = this.stock_ins.type;
        }
      },
    },
    addMaterial: {
      handler() {
        if (this.addMaterial && this.addMaterial.material_id) {
          this.stock_in_details.push({
            new: this.stock_in_details.length + 1,
            stock_in_id: this.stock_ins.id,
            category_name: this.addMaterial.category_name,
            material_id: this.addMaterial.material_id,
            material_code: this.addMaterial.material_code,
            material_name: this.addMaterial.material_name,
            standard_name: this.addMaterial.standard_name,
            unit: this.addMaterial.default_unit,
            price: this.addMaterial.default_unit_supplier_price,
            memo: null,
            fee: "",
            standard_details: this.addMaterial.standard_details,
            material: this.addMaterial,
            standard_detail_id: this.addMaterial.standard_detail_id,
            order_num: "",
          });
          this.addMaterial = {
            material_code: "",
            material_name: "",
            standard_name: "",
          }; //消除显示
        }
      },
    },
    addMaterials: {
      handler() {
        this.addMaterials.forEach((addMaterial) => {
          if (addMaterial && addMaterial.material_id) {
            this.stock_in_details.push({
              new: this.stock_in_details.length + 1,
              stock_in_id: this.stock_ins.id,
              category_name: addMaterial.category_name,
              material_id: addMaterial.material_id,
              material_code: addMaterial.material_code,
              material_name: addMaterial.material_name,
              unit: addMaterial.default_unit,
              price: addMaterial.default_unit_supplier_price,
              memo: null,
              fee: "",
              standard_details: addMaterial.standard_details,
              material: addMaterial,
              standard_detail_id: addMaterial.standard_detail_id,
              order_num: "",
              standard_name: addMaterial.standard_name,
            });
          }
        });
      },
    },
    stock_in_details: {
      deep: true,
      handler() {
        let totalFee = 0;
        let countOrderNum = 0;
        let countConfirmNum = 0;
        this.stock_in_details.forEach((item) => {
          if (
            this.stock_ins.price_type == 2 &&
            this.stock_ins.type == 11 &&
            this.savable
          ) {
            if (item.order_num) item.price = item.fee / item.order_num;
            countOrderNum += item.order_num;
            countConfirmNum += item.confirm_num;
          } else if (
            this.stock_ins.price_type == 1 &&
            this.stock_ins.type == 11 &&
            this.savable
          ) {
            item.fee = item.price * item.order_num;
            countOrderNum += item.order_num;
            countConfirmNum += item.confirm_num;
          } else if (
            this.stock_ins.price_type == 1 &&
            this.stock_ins.type == 11 &&
            this.isView
          ) {
            item.fee = item.price * item.confirm_num;
            countOrderNum += item.order_num;
            countConfirmNum += item.confirm_num;
          } else if (
            this.stock_ins.price_type == 2 &&
            this.stock_ins.type == 11 &&
            this.isView
          ) {
            if (item.confirm_num) item.price = item.fee / item.confirm_num;
            countOrderNum += item.order_num;
            countConfirmNum += item.confirm_num;
          } else {
            if (this.stock_ins.status == 3) {
              item.fee = item.price * item.confirm_num;
              countOrderNum += item.order_num;
              countConfirmNum += item.confirm_num;
            } else {
              item.fee = item.price * item.order_num;
              countOrderNum += item.order_num;
              countConfirmNum += item.confirm_num;
            }
          }
          totalFee += Number(item.fee);
        });
        this.count_price = this.$numberFormatter.formatMoneyFloor(totalFee);
        this.count_order_num =
          this.$numberFormatter.formatTwoDot(countOrderNum);
        this.count_confirm_num =
          this.$numberFormatter.formatTwoDot(countConfirmNum);
      },
    },
    imgs_file: {
      deep: true,
      handler() {
        // 接口下发的老附件在前，新选择的图片预览追加在后
        var oldImgs = this.stock_ins.img ? this.stock_ins.img.slice() : [];
        if (this.imgs_file.length) {
          // 附件总数（老附件 + 新选择文件）不超过三张
          if (oldImgs.length + this.imgs_file.length > 3) {
            this.$snackbar.error(i18n.t("Examine.DetailFields.hint"));
            this.imgs_file = [];
          } else {
            this.album = oldImgs;
            this.imgs_file.forEach((img) => {
              var reader = new FileReader();
              reader.readAsDataURL(img);
              let that = this;
              reader.onload = function () {
                that.album.push(this.result);
              };
            });
          }
        } else {
          this.album = oldImgs;
        }
      },
    },
  },
};
</script>
